// extracted by mini-css-extract-plugin
export default {"summary":"TaskConversionProcessIssueFilesPage_summary__w7-h9","title":"TaskConversionProcessIssueFilesPage_title__3kDiO"};